import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { openModal } from "../../../redux/reducers/ModalManager";
import { ReduxState } from "../../../redux";
import { resumeJob } from "../../../docuclipper/api";
import { setJobData } from "../../../redux/reducers/JobData";
import { createAlert } from "../../../redux/reducers/Alerts";
import { renderUpgradeAlertBanner } from "../../../utils/AlertRenders";
export const JobOutOfPages = ({ job }) => {
  // const dispatch = useDispatch();
  // const { activeModal } = useSelector(
  //   (state: ReduxState) => state.ModalManager
  // );

  const dispatch = useDispatch();

  React.useEffect(() => {
    dispatch(
      createAlert({
        timeout: 0,
        type: "error",
        messageWithUpdate: `You've run out of pages`,
        message: "",
      })
    );
  }, []);

  const history = useHistory();
  const onResume = () => {
    console.log({ job });
    if (!job) {
      return;
    }
    resumeJob(job.id)
      .then((rsp) => {
        dispatch(setJobData({ job: rsp, progress: null }));
      })
      .catch((err) => {
        dispatch(
          createAlert({
            message: "Error resuming job",
            timeout: 0,
            type: "error",
          })
        );
      });
  };

  return (
    <div style={{ maxWidth: "50vw" }}>
      <Row className="text-center">
        <Col>
          <div style={{ maxWidth: "20vw" }}>
            <div className="h2 m-4">
              <FontAwesomeIcon /*size="8x"*/ icon="times" color="red" />{" "}
              <span className="ml-2">You've run out of pages</span>
            </div>
            <Button variant="light" className="mx-1" onClick={onResume}>
              Resume Job
            </Button>
            <Button
              className="my-2 mx-1"
              variant="primary"
              onClick={() => {
                history.push("/account/upgrade");
              }}
            >
              Upgrade
            </Button>
          </div>
        </Col>
      </Row>
    </div>
  );
};
